import { DefaultLayout } from "../../layouts/Default";
import { Main } from "../../themes/Default/components/Main";
import { Title } from "../../themes/Default/components/Title";
import { useTranslation } from "react-i18next";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";

const Support = () => {
    const { t } = useTranslation("common");

    return (
        <DefaultLayout>
            <TopNavigation>
            </TopNavigation>
            <Main>
                <Title>{t("support.title")}</Title>
                <Breadcrumps>
                </Breadcrumps>
                <p className="main-list__title">{t("comingSoon")}</p>
            </Main>
        </DefaultLayout>
    );
};

export default Support;
